// extracted by mini-css-extract-plugin
module.exports = {"root":"ListingTrustIndicator_root__XMros","text":"ListingTrustIndicator_text__v0Usk"};